export default __webpack_public_path__ + "static/media/dani.f96fd947.jpg";